// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

// 1. Crea el contexto
const AuthContext = createContext(null);

// 2. Crea el "Proveedor" que envolverá nuestra aplicación
export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try{
            const savedUser = localStorage.getItem('user');
            return savedUser ? JSON.parse(savedUser) : null;
        } catch (error){
            console.error("Failed to parse user from localStorage", error);
            return null;
        }
    }); // Por defecto, no hay usuario

    // Función para iniciar sesión
    const login = (userData) => {
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
    };

    // Función para cerrar sesión
    const logout = () => {
        localStorage.removeItem('user');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

// 3. Crea un "Hook" personalizado para usar el contexto fácilmente
export function useAuth() {
    return useContext(AuthContext);
}